import { InnerBox } from "@/components/elements/InnerBox";
import { Grid, Stack, Typography } from "@mui/material";
import { FC } from "react";
import dayjs from "dayjs";
import { TLearnerForm } from "@/features/learner/types/learnerForm";
import { ItemInfo } from "@/components/commons/ItemInfo";
import { calculateResidencePeriods } from "@/features/learner/utils/calculates";
import { DATE_FORMAT } from "@/constants/datetime";

type TLearnerResidenceInfoDetailProps = {
  data?: Partial<TLearnerForm>;
};

export const LearnerResidenceInfoDetail: FC<TLearnerResidenceInfoDetailProps> = ({ data }) => {
  const periods = calculateResidencePeriods(data?.clause1StartDate, data?.blankPeriodMonths);

  return (
    <Stack gap={2}>
      <InnerBox
        title={<Typography variant="head20Bold">在留資格情報</Typography>}
        showDivider={false}
      >
        <Grid container rowSpacing={2} columnSpacing={3}>
          <Grid item xs={6}>
            <ItemInfo
              label="1号の起算日"
              value={
                data?.clause1StartDate && dayjs(data.clause1StartDate).isValid()
                  ? dayjs(data.clause1StartDate).format(DATE_FORMAT)
                  : ""
              }
            />
          </Grid>
          <Grid item xs={6}>
            <ItemInfo
              label="ブランク期間（月単位）"
              value={data?.blankPeriodMonths ? `${data.blankPeriodMonths}か月` : ""}
            />
          </Grid>
          <Grid item xs={6}>
            <ItemInfo
              label="1号経過期間（自動計算）"
              value={periods.elapsed}
            />
          </Grid>
          <Grid item xs={6}>
            <ItemInfo
              label="1号残期間（自動計算）"
              value={periods.remaining}
            />
          </Grid>
        </Grid>
      </InnerBox>
    </Stack>
  );
};
